module.exports = __webpack_public_path__ + "static/media/Butterfly_1_small.94852ec4.png";